import axiosInstance from '../../utils/axiosInstance';

const BASE_URL = '/expenses';

class ExpenseManager {
  async getAllExpenses() {
    try {
      const response = await axiosInstance.get(`${BASE_URL}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching all expenses:", error);
      throw error;
    }
  }

  async getExpensesByMonth(year, month) {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/monthly`, {
        params: { year, month }
      });
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching monthly expenses:", error);
      throw error;
    }
  }

  async getMonthlyExpenseSummary(year, month) {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/monthly-summary`, {
        params: { year, month }
      });
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching monthly expense summary:", error);
      throw error;
    }
  }

  async createExpense(expenseData) {
    try {
      const response = await axiosInstance.post(`${BASE_URL}`, expenseData);
      return response.data;
    } catch (error) {
      console.error("Error creating expense:", error);
      throw error;
    }
  }

  async updateExpense(expenseId, expenseData) {
    try {
      const response = await axiosInstance.put(`${BASE_URL}/${expenseId}`, expenseData);
      return response.data;
    } catch (error) {
      console.error("Error updating expense:", error);
      throw error;
    }
  }

  async deleteExpense(expenseId) {
    try {
      const response = await axiosInstance.delete(`${BASE_URL}/${expenseId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting expense:", error);
      throw error;
    }
  }
}

const expenseManager = new ExpenseManager();
export default expenseManager;
